import React, { useState } from 'react';
import { trackInitiateCheckout } from '../utils/metaPixel';
type UpsellStep = 'order-bump' | 'downsell';
export function UpsellPopup({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const [step, setStep] = useState<UpsellStep>('order-bump');
  const handleCheckout = (url: string) => {
    trackInitiateCheckout();
    window.location.href = url;
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[99999] flex items-center justify-center p-4" data-id="element-487">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-488" />

      {/* Modal */}
      <div className={`relative bg-white rounded-2xl shadow-2xl w-[90%] max-w-[480px] max-h-[90vh] overflow-y-auto ${step === 'order-bump' ? 'animate-[scaleIn_0.3s_ease]' : 'animate-[shake_0.5s_ease]'}`} data-id="element-489">
        {step === 'order-bump' && <div className="p-5 sm:p-8" data-id="element-490">
            {/* Image Header */}
            <div className="relative -mx-5 -mt-5 sm:-mx-8 sm:-mt-8 mb-6 rounded-t-2xl overflow-hidden" data-id="element-491">
              <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/06_Union_en_el_trabajo__construccion_y_liderazgo.png?v=1775530362" alt="Escudo contra el Abuso Laboral" className="w-full h-48 object-cover" data-id="element-492" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-493"></div>
              <div className="absolute bottom-3 left-4 right-4" data-id="element-494">
                <span className="bg-red-600 text-white text-xs font-black px-3 py-1 rounded-full uppercase" data-id="element-495">
                  ⚠️ Alerta importante
                </span>
              </div>
            </div>

            <h3 className="text-xl sm:text-2xl font-black text-brand-navy font-montserrat mb-4 text-center leading-tight" data-id="element-496">
              🛡️ ¡ESPÉRATE! TU SEMANA DE TRABAJO ESTÁ EN RIESGO...
            </h3>

            <p className="text-sm sm:text-base text-brand-textSecondary leading-relaxed mb-6 text-center" data-id="element-497">
              ¿Sabías que miles de hombres pierden su pago cada viernes porque
              el patrón "no tiene dinero"? No dejes tu esfuerzo al azar. Añade
              el{' '}
              <strong className="text-brand-navy" data-id="element-498">
                Bono #4: El Escudo contra el Abuso Laboral
              </strong>{' '}
              por solo{' '}
              <strong className="text-brand-emerald font-black" data-id="element-499">$9.00</strong>{' '}
              adicionales. Aprende a forzar tu pago legalmente si intentan
              engañarte.{' '}
              <span className="text-brand-textSecondary/60 text-xs" data-id="element-500">
                (Precio regular: $27.00)
              </span>
            </p>

            <button onClick={() => handleCheckout('https://www.betterdailyguides.com/cart/51935861637422:1')} className="btn-buy-main block w-full text-center py-4 px-6 text-base font-black uppercase tracking-wide mb-3 border-none cursor-pointer min-h-[54px]" data-id="element-501">
              SÍ, AÑADIR PROTECCIÓN LABORAL ($23)
            </button>

            <button onClick={() => setStep('downsell')} className="block w-full text-center py-3 text-sm text-brand-textSecondary/70 underline bg-transparent border-none cursor-pointer hover:text-brand-navy transition-colors" data-id="element-502">
              No, prefiero arriesgarme y continuar con la guía regular ($14)
            </button>
          </div>}

        {step === 'downsell' && <div className="p-5 sm:p-8" data-id="element-503">
            {/* Urgency Banner */}
            <div className="bg-red-50 border border-red-200 rounded-xl p-3 mb-6 text-center" data-id="element-504">
              <span className="text-red-600 font-bold text-sm" data-id="element-505">
                ⏰ Esta oferta desaparece al cerrar esta ventana
              </span>
            </div>

            <div className="text-center mb-6" data-id="element-506">
              <div className="text-5xl mb-3" data-id="element-507">🎁</div>
              <h3 className="text-xl sm:text-2xl font-black text-brand-navy font-montserrat mb-2 leading-tight" data-id="element-508">
                ¡SOLO POR ESTA VEZ! NO TE VAYAS SIN PROTECCIÓN
              </h3>
            </div>

            <p className="text-sm sm:text-base text-brand-textSecondary leading-relaxed mb-6 text-center" data-id="element-509">
              Entiendo que el presupuesto está ajustado, pero tu sudor vale
              demasiado. Llévate el{' '}
              <strong className="text-brand-navy" data-id="element-510">Escudo Laboral</strong> con un{' '}
              <strong className="text-brand-emerald font-black text-lg" data-id="element-511">
                35% de Descuento adicional
              </strong>
              . Solo por hoy:{' '}
              <span className="text-brand-emerald font-black text-xl" data-id="element-512">
                $5.85
              </span>
              .
            </p>

            <button onClick={() => handleCheckout('https://www.betterdailyguides.com/cart/51935861834030:1')} className="btn-buy-main block w-full text-center py-4 px-6 text-base font-black uppercase tracking-wide mb-3 border-none cursor-pointer min-h-[54px] animate-[btnPulse_2s_ease-in-out_infinite]" data-id="element-513">
              OK, APROVECHAR DESCUENTO FINAL ($19.85)
            </button>

            <button onClick={() => {
          trackInitiateCheckout();
          window.location.href = 'https://www.betterdailyguides.com/cart/51935859671342:1';
        }} className="block w-full text-center py-3 text-xs text-brand-textSecondary/60 underline bg-transparent border-none cursor-pointer hover:text-brand-navy transition-colors" data-id="element-514">
              No, continuar con mi orden regular de $14
            </button>
          </div>}
      </div>
    </div>;
}